var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "v-container",
        { staticClass: "text-center" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", lg: "8" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      filled: "",
                      "data-cy": "FormFleetSupplier-name",
                      label: _vm.$$t("name"),
                    },
                    model: {
                      value: _vm.localFleetSupplier.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFleetSupplier, "name", $$v)
                      },
                      expression: "localFleetSupplier.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", lg: "4" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      filled: "",
                      "data-cy": "FormFleetSupplier-phone",
                      label: _vm.$$t("phone"),
                    },
                    model: {
                      value: _vm.localFleetSupplier.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFleetSupplier, "phone", $$v)
                      },
                      expression: "localFleetSupplier.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-textarea", {
                    attrs: {
                      filled: "",
                      rows: "3",
                      "auto-grow": "",
                      "data-cy": "FormFleetSupplier-address",
                      label: _vm.$$t("address"),
                    },
                    model: {
                      value: _vm.localFleetSupplier.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFleetSupplier, "address", $$v)
                      },
                      expression: "localFleetSupplier.address",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-end mb-6" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-4 btn-cancel",
                  attrs: {
                    color: "default",
                    outlined: "",
                    "data-cy": "FormFleetSupplier-button-cancel",
                  },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  attrs: {
                    color: "primary",
                    type: "submit",
                    loading: _vm.isSaving,
                    "data-cy": "FormFleetSupplier-button-save",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }